import React, { useEffect } from 'react'
import { useDataValue, useDataChange } from 'Simple/Data'

import { useMutation } from 'Data/Api.js'

import mutation from './mutation.graphql.js'
import View from './view.js'
import { notifyError, useNotifications } from 'Logic/Notifications'

export default function Logic(props) {
  let patient_id = useDataValue({
    context: 'lead',
    path: '[0].patient_id',
    viewPath: props.viewPath,
  })

  let change = useDataChange({
    context: 'selected',
    path: 'medical_form_url',
    viewPath: props.viewPath,
  })

  let [, executeMutation] = useMutation(mutation)
  let [, notify] = useNotifications()

  async function updateMedicalFormUrl() {
    if (!patient_id) return

    try {
      let res = await executeMutation({
        patient_id,
      })

      if (res.error) {
        notify(
          notifyError(
            `There was an error retrieving the medical form, please check your mail`
          )
        )
      }

      change(res.data.medical_form_generate_url.url)
    } catch (error) {
      notify(
        notifyError(
          `There was an error retrieving the medical form, please check your mail`
        )
      )
    }
  }

  useEffect(() => {
    updateMedicalFormUrl()
  }, [patient_id]) //eslint-disable-line

  return <View {...props} />
}
